import { createContext } from 'react';
import type { MyIpAssetReturnHost, MyIpAssetReturnRequest } from '$/domains/myIp/returnState';

export interface MyIpReturnHost {
  host: MyIpAssetReturnHost;
  restored?: MyIpAssetReturnRequest;
  onRestored?: () => void;
}
export const MyIpReturnHostContext = createContext<MyIpReturnHost | undefined>(undefined);
